import { motion } from 'framer-motion';
import { Building2, DollarSign, Calendar, Info } from 'lucide-react';
import { useTranslation } from '@/i18n';
import { useReducedMotion } from '@/hooks/useReducedMotion';
import type { TranslationKey } from '@pullman/shared';

interface StarterButton {
  key: TranslationKey;
  icon: typeof Building2;
}

const STARTERS: StarterButton[] = [
  { key: 'landing.explore', icon: Building2 },
  { key: 'landing.pricing', icon: DollarSign },
  { key: 'landing.schedule', icon: Calendar },
  { key: 'landing.about', icon: Info },
];

interface StarterButtonsProps {
  onSelect: (message: string) => void;
}

export function StarterButtons({ onSelect }: StarterButtonsProps) {
  const { t } = useTranslation();
  const reduced = useReducedMotion();

  return (
    <div className="flex flex-wrap justify-center gap-3 px-4">
      {STARTERS.map((starter, i) => {
        const Icon = starter.icon;
        return (
          <motion.button
            key={starter.key}
            initial={reduced ? undefined : { opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.5 + i * 0.08, ease: 'easeOut' }}
            onClick={() => onSelect(t(starter.key))}
            className="flex items-center gap-2 px-5 py-2.5 rounded-full
              border border-brand-gold/40 bg-white/5 backdrop-blur-sm
              text-white/90 text-sm font-body
              hover:bg-brand-gold/20 hover:border-brand-gold/60 hover:text-white
              active:scale-95 transition-all"
          >
            <Icon size={16} className="text-brand-gold-light" />
            <span>{t(starter.key)}</span>
          </motion.button>
        );
      })}
    </div>
  );
}
